import PropTypes from "prop-types";
import CustomInput from "../../../../components/CustomForm/CustomInput";
import CustomSelect from "../../../../components/CustomForm/CustomSelect";
import CustomButton from "../../../../components/CustomButton/CustomButton";
import {
  FormWrapper,
  Form,
  FormGroup
} from "../../../../components/CustomForm/FormStyles";
import Colors from "../../../../themes/Colors";
import { ESTADOS_PRECERTIFICACION } from "../../constantes";

const StandVirtualReportesBusquedaForm = ({
  fechaDesde,
  fechaHasta,
  estatus,
  tipoPss,
  codigoPss,
  tipoBusqueda,
  buscar,
  onStateChange,
  onSearch,
  onExport,
  isLoadingCatalogos = false
}) => {
  const estatusOptions = Object.values(ESTADOS_PRECERTIFICACION).map(
    (estado) => ({
      label: estado.texto,
      value: estado.valor
    })
  );

  return (
    <FormWrapper borderColor={Colors.transparent}>
      <Form justifyContent={"space-between"} flexDirection={"column"}>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginBottom: "20px",
            gap: "2px"
          }}
        >
          <FormGroup width={"30%"}>
            <CustomInput
              type={"date"}
              label={"Fecha desde"}
              isLabelWithContainer={true}
              value={fechaDesde}
              onChange={onStateChange("fechaDesde")}
            />
          </FormGroup>
          <FormGroup width={"30%"}>
            <CustomInput
              type={"date"}
              label={"Fecha hasta"}
              isLabelWithContainer={true}
              value={fechaHasta}
              onChange={onStateChange("fechaHasta")}
            />
          </FormGroup>
          <FormGroup width={"30%"}>
            <CustomSelect
              label={"Estatus"}
              isLabelWithContainer={true}
              options={estatusOptions}
              value={estatus}
              onChange={onStateChange("estatus")}
              isLoading={isLoadingCatalogos}
            />
          </FormGroup>
        </div>

        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginBottom: "20px",
            gap: "2px"
          }}
        >
          <FormGroup width={"48%"}>
            <CustomSelect
              label={"Tipo PSS"}
              isLabelWithContainer={true}
              options={[
                { value: "MEDICO", label: "MEDICO" },
                { value: "NO_MEDICO", label: "NO MEDICO" }
              ]}
              value={tipoPss}
              onChange={onStateChange("tipoPss")}
              isLoading={isLoadingCatalogos}
            />
          </FormGroup>
          <FormGroup width={"48%"}>
            <CustomInput
              type={"text"}
              placeholder={"Código PSS"}
              label={"Código PSS"}
              isLabelWithContainer={true}
              value={codigoPss}
              onChange={onStateChange("codigoPss")}
            />
          </FormGroup>
        </div>

        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginBottom: "20px",
            gap: "2px"
          }}
        >
          <FormGroup width={"48%"}>
            <CustomSelect
              label={"Buscar por"}
              isLabelWithContainer={true}
              options={[
                { value: "numeroSolicitud", label: "No. Solicitud" },
                { value: "numeroAutorizacion", label: "No. Autorización" },
                { value: "asegurado", label: "Asegurado" }
              ]}
              value={tipoBusqueda}
              onChange={onStateChange("tipoBusqueda")}
              isLoading={isLoadingCatalogos}
            />
          </FormGroup>
          <FormGroup width={"48%"}>
            <CustomInput
              type={"text"}
              placeholder={"Buscar..."}
              label={"Valor a buscar"}
              isLabelWithContainer={true}
              value={buscar}
              onChange={onStateChange("buscar")}
            />
          </FormGroup>
        </div>

        <div
          style={{
            display: "flex",
            justifyContent: "flex-start",
            alignItems: "flex-end",
            gap: "20px"
          }}
        >
          <CustomButton
            label={"Buscar"}
            onClick={onSearch}
            height={"46px"}
            width={"120px"}
            bgColor={Colors.primaryPrimera}
            hoverColor={Colors.darkGreenPrimera}
            textColor={Colors.white}
            hoverTextColor={Colors.white}
          />
          <CustomButton
            label={"Exportar Excel"}
            onClick={() => onExport("excel")}
            height={"46px"}
            width={"150px"}
            bgColor={Colors.primaryPrimera}
            hoverColor={Colors.darkGreenPrimera}
            textColor={Colors.white}
            hoverTextColor={Colors.white}
          />
          <CustomButton
            label={"Exportar Pdf"}
            onClick={() => onExport("pdf")}
            height={"46px"}
            width={"150px"}
            bgColor={Colors.primaryPrimera}
            hoverColor={Colors.darkGreenPrimera}
            textColor={Colors.white}
            hoverTextColor={Colors.white}
          />
        </div>
      </Form>
    </FormWrapper>
  );
};

StandVirtualReportesBusquedaForm.propTypes = {
  fechaDesde: PropTypes.string.isRequired,
  fechaHasta: PropTypes.string.isRequired,
  estatus: PropTypes.string.isRequired,
  tipoPss: PropTypes.string.isRequired,
  codigoPss: PropTypes.string,
  buscar: PropTypes.string,
  onStateChange: PropTypes.func.isRequired,
  onSearch: PropTypes.func.isRequired,
  onExportExcel: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
  estatusOptions: PropTypes.array,
  tipoPssOptions: PropTypes.array,
  isLoadingCatalogos: PropTypes.bool
};

export default StandVirtualReportesBusquedaForm;
